/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/blocks/list.module.scss';

const propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
        }),
    ),
    className: PropTypes.string,
    titleClassName: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    items: null,
    className: null,
    isContainer: false,
    titleClassName: null,
    containerClassName: null,
};

const ListBlock = ({
    title,
    items,
    className,
    isContainer,
    titleClassName,
    containerClassName,
}) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [containerClassName]: containerClassName !== null,
            },
        ])}
    >
        <div
            className={classNames([
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                },
            ])}
        >
            {title !== null ? (
                <div
                    className={classNames([
                        styles.title,
                        {
                            [titleClassName]: titleClassName !== null,
                        },
                    ])}
                >
                    {title}
                </div>
            ) : null}
            <div
                className={classNames([
                    styles.items,
                    {
                        [styles.withTitle]: title !== null,
                    },
                ])}
            >
                <ul className={styles.list}>
                    {(items || []).map((item, itemI) => {
                        const { label = null } = item || {};
                        return label !== null ? (
                            <li key={`list-item-${itemI + 1}`}>{label}</li>
                        ) : null;
                    })}
                </ul>
            </div>
        </div>
    </div>
);

ListBlock.propTypes = propTypes;
ListBlock.defaultProps = defaultProps;

export default ListBlock;
